import { FC } from 'react';
import { gql } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Select } from '@/components/react-hook-form/Select';
import { useQuery } from '@/hooks/graphql/useQuery';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import type { Schema } from '../../schema';

const ALL_HEALTH_CHECKUP_INSTITUTIONS = gql`
  query allHealthCheckupInstitutions {
    client {
      id
      allHealthCheckupInstitutions {
        id
        name
      }
    }
  }
`;

interface AllHealthCheckupInstitutionsQueryResult {
  client: {
    id: string;
    allHealthCheckupInstitutions: {
      id: string;
      name: string;
    }[];
  };
}

export const HealthCheckupInstitution: FC = () => {
  const {
    formState: { errors }
  } = useFormContext<Schema>();

  const { data, loading } = useQuery<AllHealthCheckupInstitutionsQueryResult>(ALL_HEALTH_CHECKUP_INSTITUTIONS, {
    fetchPolicy: 'network-only'
  });
  const options = data
    ? [
        { value: '', label: '' },
        ...data.client.allHealthCheckupInstitutions.map(item => ({ value: item.id, label: item.name }))
      ]
    : [{ value: '', label: '' }];

  return (
    <Panel>
      <Headding>健康診断実施機関</Headding>
      <Item>
        <Select name="healthCheckupInstitutionId" options={options} disabled={loading} isLoading={loading} />
        {errors.healthCheckupInstitutionId?.message && (
          <ErrorMessage>{errors.healthCheckupInstitutionId.message}</ErrorMessage>
        )}
      </Item>
    </Panel>
  );
};
